module.exports = __webpack_public_path__ + "static/media/labelValue-chart.06f571d5.svg";